module.exports = __webpack_public_path__ + "static/media/crown.e64881d2.svg";